// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__C4bmV","imageUploader":"EGiftCard_imageUploader__1myTF"};